import React, {Suspense} from 'react';
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {
    ReportExecutionSingleVoyageLazy
} from "@containers/singleVoyage/reports/reportExecution/ReportExecutionSingleVoyage.lazy";


const ReportExecutionSingleVoyagePage = () => {
    return (
        <PageLayout>
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <ReportExecutionSingleVoyageLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default ReportExecutionSingleVoyagePage;